var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileLuckydrawSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_35979",
    "data-name": "Group 35979",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 41.144,
    height: 32,
    viewBox: "0 0 41.144 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5756",
    "data-name": "Rectangle 5756",
    width: 41.144,
    height: 32,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35978",
    "data-name": "Group 35978",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39658",
    "data-name": "Path 39658",
    d: "M36.572,16a4.571,4.571,0,0,0,4.572,4.572v6.857A4.572,4.572,0,0,1,36.572,32h-32A4.572,4.572,0,0,1,0,27.428V20.572a4.572,4.572,0,1,0,0-9.143V4.572A4.572,4.572,0,0,1,4.572,0h32a4.572,4.572,0,0,1,4.572,4.572v6.857A4.571,4.571,0,0,0,36.572,16",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39659",
    "data-name": "Path 39659",
    d: "M256.872,267.242l-.282,3.17.282,3.17L259.618,272l2.745-1.585-2.464-1.866Z",
    transform: "translate(-238.185 -248.072)",
    fill: "#080909",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39660",
    "data-name": "Path 39660",
    d: "M333.412,223.052l-.282,3.17.282,3.17,2.745-1.585,2.745-1.585-2.464-1.866Z",
    transform: "translate(-309.234 -207.051)",
    fill: "#080909",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39661",
    "data-name": "Path 39661",
    d: "M333.412,141.007l-.282-3.17.282-3.17,2.745,1.585,2.745,1.585-2.464,1.866Z",
    transform: "translate(-309.234 -125.007)",
    fill: "#080909",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39662",
    "data-name": "Path 39662",
    d: "M337.058,182.029l2.745-1.585,2.745-1.585v6.34l-2.745-1.585Z",
    transform: "translate(-312.88 -166.029)",
    fill: "#080909",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39663",
    "data-name": "Path 39663",
    d: "M256.872,96.816l-.282-3.17.282-3.17,2.745,1.585,2.745,1.585L259.9,95.513Z",
    transform: "translate(-238.185 -83.986)",
    fill: "#080909",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39664",
    "data-name": "Path 39664",
    d: "M260.516,137.838l2.745-1.585,2.745-1.585v6.34l-2.745-1.585Z",
    transform: "translate(-241.828 -125.008)",
    fill: "#080909",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39665",
    "data-name": "Path 39665",
    d: "M183.973,98.405h5.491V90.477l-2.745,1.585-2.745,1.585",
    transform: "translate(-170.777 -83.987)",
    fill: "#080909",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39666",
    "data-name": "Path 39666",
    d: "M183.973,245.1h5.491v7.928l-2.745-1.585-2.745-1.585",
    transform: "translate(-170.777 -227.518)",
    fill: "#080909",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39667",
    "data-name": "Path 39667",
    d: "M260.516,226.22l2.745,1.585,2.745,1.585v-6.34l-2.745,1.585Z",
    transform: "translate(-241.828 -207.05)",
    fill: "#080909",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileLuckydrawSymbol);
export default __webpack_public_path__ + "static/media/profile-luckydraw-symbol.5c8e2a3bacaaba573ecefb5d152beb7c.svg";
export { ForwardRef as ReactComponent };